import { GenericRecord, GenericNumericalRecord } from './utils';

export const calculateAdjustedPtbi = (input: GenericRecord = {}) => {
  const { adjustments, ptbi }: GenericNumericalRecord = input;
  return (ptbi ?? 0) + (adjustments ?? 0);
};
